import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddressPipe } from './address/address.pipe';
import { DecimalToHourFormatPipe } from './decimal-to-hour-format/decimal-to-hour-format.pipe';
import { DisabledWeekdaysRangePipe } from './disabled-weekdays-range/disabled-weekdays-range.pipe';
import { FormControlInvalidPipe } from './form-control-invalid/form-control-invalid.pipe';
import { InvoiceNumberPipe } from './invoice/invoice-number.pipe';
import { IsTodayPipe } from './is-today/is-today.pipe';
import { LocalizedNumberPipe } from './localized-number/localized-number.pipe';
import { LocationNameSubPipe } from './location-name-sub/location-name-sub.pipe';
import { LocationNamePipe } from './location-name/location-name.pipe';
import { NavigateToServicePipe } from './navigate-to-service/navigate-to-service.pipe';
import { ProjectNamePipe } from './projects/project-name.pipe';
import { SelectedAgreementPipe } from './selected-agreement/selected-agreement.pipe';
import { HoursToHoursMinutesPipe } from './hours-to-hours-minutes/hours-to-hours-minutes.pipe';

@NgModule({
  declarations: [
    HoursToHoursMinutesPipe,
    IsTodayPipe,
    DisabledWeekdaysRangePipe,
    SelectedAgreementPipe,
    FormControlInvalidPipe,
    LocationNameSubPipe,
    AddressPipe,
    NavigateToServicePipe,
    ProjectNamePipe,
    InvoiceNumberPipe,
    DecimalToHourFormatPipe,
  ],
  providers: [
    AddressPipe,
    LocationNamePipe,
    LocationNameSubPipe,
    FormControlInvalidPipe,
    InvoiceNumberPipe,
  ],
  imports: [CommonModule, LocalizedNumberPipe, LocationNamePipe],
  exports: [
    HoursToHoursMinutesPipe,
    IsTodayPipe,
    DisabledWeekdaysRangePipe,
    SelectedAgreementPipe,
    FormControlInvalidPipe,
    LocalizedNumberPipe,
    LocationNamePipe,
    LocationNameSubPipe,
    AddressPipe,
    NavigateToServicePipe,
    ProjectNamePipe,
    InvoiceNumberPipe,
    DecimalToHourFormatPipe,
  ],
})
export class PipesModule {}
